var portfolioEvaluationChart = {
	"3m": "3M",
	"1y": "1J",
	"1stTrade": "Seit dem ersten Handel",
	rangeDescription: "Spanne {start} bis {end}"
};
var de = {
	portfolioEvaluationChart: portfolioEvaluationChart
};

export { de as default, portfolioEvaluationChart };
